<opac-button class="record" *ngIf="location === 'RECORD'" [ariaLabel]="tooltipText" [opacTooltip]="tooltipText">
  <opac-icon slot="only-icon" [ariaHidden]="ariaHideLigature" [icon]="iconLigature"></opac-icon>
</opac-button>

<opac-button class="platform" *ngIf="location === 'PLATFORM'" [ariaLabel]="tooltipText" [opacTooltip]="tooltipText">
  <opac-icon slot="only-icon" [ariaHidden]="ariaHideLigature" [icon]="iconLigature"></opac-icon>
</opac-button>

<opac-button class="footer" *ngIf="location === 'FOOTER'" [ariaLabel]="tooltipText" [opacTooltip]="tooltipText">
  <opac-icon slot="only-icon" [ariaHidden]="ariaHideLigature" [icon]="iconLigature"></opac-icon>
</opac-button>
